import { UtilityBillFormData } from "types";

/**
 * Checks if form has all initial required values filled
 * @param defaultValues - Default form values
 * @returns true if all required fields have values
 */
export const hasInitialFormValues = (defaultValues: UtilityBillFormData): boolean =>
    (defaultValues as any).endDate !== "" &&
    (defaultValues as any).startDate !== "" &&
    defaultValues.measuredUnit !== "" &&
    defaultValues.measuredValue !== "" &&
    defaultValues.meterNumber !== "" &&
    defaultValues.accountNumber !== "" &&
    defaultValues.utilityTypeName !== "" &&
    defaultValues.subtype !== "" &&
    defaultValues.amount !== "" &&
    defaultValues.currency !== "";

/**
 * Calculates unit cost string from currency and measured unit
 * @param currency - Currency value
 * @param measuredUnit - Measured unit value
 * @returns Formatted unit cost string (e.g., "USD/kWh") or empty string
 */
export const calculateUnitCost = (
    currency?: string,
    measuredUnit?: string
): string => {
    if (!currency || !measuredUnit) {
        return "";
    }
    return `${currency}/${measuredUnit}`;
};

/**
 * Determines if subtype field should be shown based on utility type
 * @param utilityTypeName - Name of the utility type
 * @returns true if subtype should be shown
 */
export const shouldShowSubtype = (utilityTypeName?: string): boolean => {
    if (!utilityTypeName) {
        return false;
    }
    const subtypesToShow = [
        "Refrigerants",
        "Gasoline Vehicle",
        "Hybrid Vehicle",
        "Diesel Vehicle",
    ];
    return subtypesToShow.includes(utilityTypeName);
};

/**
 * Checks if collector is empty (default empty state)
 * @param collectorString - Collector string value
 * @returns true if collector is empty
 */
export const isCollectorEmpty = (collectorString?: string | null): boolean =>
    collectorString === "- / - / -" || !collectorString;

